var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGoodC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 85.04C66.0032 85.04 85.04 66.0031 85.04 42.52C85.04 19.0369 66.0032 0 42.52 0C19.0369 0 0 19.0369 0 42.52C0 66.0031 19.0369 85.04 42.52 85.04Z",
    fill: "#FCC332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 61.63C37.93 61.63 33.77 58.73 32.16 54.43C31.87 53.65 32.26 52.79 33.04 52.5C33.82 52.21 34.68 52.6 34.97 53.38C36.14 56.52 39.18 58.63 42.52 58.63C45.86 58.63 48.9 56.52 50.07 53.38C50.36 52.6 51.23 52.21 52 52.5C52.78 52.79 53.17 53.65 52.88 54.43C51.27 58.74 47.11 61.63 42.52 61.63Z",
    fill: "#331100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.48 59.8C72.6336 59.8 75.19 57.2436 75.19 54.09C75.19 50.9365 72.6336 48.38 69.48 48.38C66.3265 48.38 63.77 50.9365 63.77 54.09C63.77 57.2436 66.3265 59.8 69.48 59.8Z",
    fill: "#FF5D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.21 59.8C19.3636 59.8 21.92 57.2436 21.92 54.09C21.92 50.9365 19.3636 48.38 16.21 48.38C13.0565 48.38 10.5 50.9365 10.5 54.09C10.5 57.2436 13.0565 59.8 16.21 59.8Z",
    fill: "#FF5D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.95 52.32C24.2972 52.32 26.2 50.4172 26.2 48.07C26.2 45.7228 24.2972 43.82 21.95 43.82C19.6027 43.82 17.7 45.7228 17.7 48.07C17.7 50.4172 19.6027 52.32 21.95 52.32Z",
    fill: "#331100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 52.32C65.4472 52.32 67.35 50.4172 67.35 48.07C67.35 45.7228 65.4472 43.82 63.1 43.82C60.7528 43.82 58.85 45.7228 58.85 48.07C58.85 50.4172 60.7528 52.32 63.1 52.32Z",
    fill: "#331100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoodC);
export default __webpack_public_path__ + "static/media/ic_good_c.accadac4facf194242c3f3f3bb09ed16.svg";
export { ForwardRef as ReactComponent };